/**
 * Telling "nothing uploaded yet" apart from "something broke".
 *
 * Separate from the panel that renders it because a module exporting both a component and
 * its helpers breaks fast refresh, the same reason `targets-math.ts` sits apart from
 * `TargetsDialog.tsx`.
 */

/** Where uploading happens. Deliberately not a nav item, per review. */
export const BILLINGS_UPLOAD_PATH = '/sales-trackers/upload'

/**
 * Is this the "no billings uploaded yet" 404 rather than a real failure?
 *
 * Every Sales Trackers page resolves its fiscal year from the data that exists, so with an
 * empty billings schema the API answers 404 with instructions. Reads the status the way
 * `MySales.tsx` already does for its own expected 404.
 *
 * Deliberately does NOT match on the message text. Copy gets rewritten, and a predicate
 * keyed to wording would silently stop matching, putting the red "record couldn't be found"
 * box back on a brand new database without a single test failing.
 */
export function isNoBillingsYet(error: unknown): boolean {
  return (error as { response?: { status?: number } } | null)?.response?.status === 404
}
